(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsDoserViewModel', facilityDetailsDoserViewModelFactory);

  /** @ngInject */
  function facilityDetailsDoserViewModelFactory(doserSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsDoserViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_EMV_SPREMNIK_PRASKA] = 'vent';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_MAX_NIVO_PRASAK] = 'highFloat';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_MIN_NIVO_PRASAK] = 'lowFloat';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_RAD] = 'motor';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_GRE_MZS] = 'motorError';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_RAD] = 'motorDoser';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_GRE_MZS] = 'motorDoserError';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_VIBRATOR_PRASKA_GRE_MZS] = 'motorVibroError';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(doserSubsystemUtils.getDoserSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsDoserViewModel.prototype.destroy = function () {

    };

    FacilityDetailsDoserViewModel.prototype.refresh = function (doserPointJson) {
      this.pointId = doserPointJson.id;
      this.name = doserPointJson.name;
      this.pointType = doserPointJson.pointType;
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_EMV_SPREMNIK_PRASKA));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_MAX_NIVO_PRASAK));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_MIN_NIVO_PRASAK));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_RAD));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_GRE_MZS));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_RAD));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_GRE_MZS));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_VIBRATOR_PRASKA_GRE_MZS));
    };

    FacilityDetailsDoserViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsDoserViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();
